<template>
  <!--Für die Bearbeitung nur Täglig und Wochentlich. als neue Komponente SogScheduleSerie
  <ScheduleComponent
    :current-view="currentView"
    :selected-date="selectedDate"
  /> -->
  <SogForm ref="_schedule">
    <SogFlexRow>
      <SogFormField>
        <SogDropDownList
          v-model="_currentView"
          :data-source="_lstViews"
        />
      </SogFormField>
      <SogFormField>
        <SogTextBox
          v-model="_selectedDate"
        />
      </SogFormField>
    </SogFlexRow>
  </SogForm>
</template>

<script setup lang="ts">
import {ref, reactive} from "vue";
import SogForm from "@/shared/ui/SogForm.vue";
import sogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";

const _schedule = ref<InstanceType<typeof sogForm> | null>(null)
const _currentView = ref<string>("Day")
const _selectedDate = ref(new Date().toLocaleTimeString())
const _lstViews = reactive([
  {
    id: "Day",
    value: "täglich"
  },
  {
    id: "Week",
    value: "wöchentlich",
  },
]);

interface Props {
  //currentView?: string,
  nextInvoiceDate?: Date,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    //currentView: "Day",
    nextInvoiceDate: undefined,
  }
)

</script>

<style scoped />
